import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { EnumActionsPermissions } from '@models/EnumPermissions';

@Component({
    selector: 'configurations-unassigned-cards',
    templateUrl: './unassigned-cards.component.html',
    styleUrls: ['./unassigned-cards.component.scss'],
})
export class UnassignedCardsConfigurationsComponent implements OnInit, OnChanges {

    @Input('data') Data: any[] = [];
    public EnumActionsPermissions = EnumActionsPermissions;
    constructor() { }


    ngOnInit() {

        console.log(this.Data);

    }

    ngOnChanges(changes: SimpleChanges): void {

        console.log(changes, this.Data);

    }
}
